export default __webpack_public_path__ + "static/bg-elevating-dock-50bf522a9a6929840780e430f9d719ee.png";